// import parseDate from "src/lib/parseDate";

// const ParseDate = ({ date, format = null }) => (
//   <span style={{ whiteSpace: "nowrap" }}>{parseDate(date, format)}</span>
// );

// export const CreatedDate = ({ date }) => (
//   <ParseDate date={date} format="YYYY/MM/DD" />
// );

// export default ParseDate;
import parseDate from "src/lib/parseDate";

// Component to display the formatted date
const ParseDate = ({ date }) => (
  <span style={{ whiteSpace: "nowrap" }}>{parseDate(date)}</span>
);

export default ParseDate;

